import { useEffect, useState } from 'react';
export function useVectorLayerLoading(layer) {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!layer) {
            setLoading(false);
            return;
        }
        const source = layer.getSource();
        if (!source) {
            setLoading(false);
            return;
        }
        let loadingCount = 0;
        const handleLoadStart = () => {
            loadingCount++;
            setLoading(true);
        };
        const handleLoadEnd = () => {
            loadingCount = Math.max(0, loadingCount - 1);
            if (loadingCount === 0) {
                setLoading(false); // všechna data načtena
            }
        };
        source.on('featuresloadstart', handleLoadStart);
        source.on('featuresloadend', handleLoadEnd);
        source.on('featuresloaderror', handleLoadEnd);
        return () => {
            source.un('featuresloadstart', handleLoadStart);
            source.un('featuresloadend', handleLoadEnd);
            source.un('featuresloaderror', handleLoadEnd);
        };
    }, [layer]);
    return loading;
}
//# sourceMappingURL=useVectorLayerLoading.js.map